
















































import Vue, { PropOptions } from 'vue';

export default Vue.extend({
  name: 'SPagination',
  props: {
    /**
     * The number of items per page
     */
    pageSize: {
      type: Number,
      required: true,
    },
    /**
     * The page selected
     */
    currentPage: {
      type: Number,
      required: true,
    },
    /**
     * The number of items in total. (Is used to work out how many pages there should be)
     */
    numberOfItems: {
      type: Number,
      required: true,
    },
    /**
     * If pagination should show its loading state
     */
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * If the pagination should be disabled
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * The page size options
     */
    pageSizeOptions: {
      type: Array,
      required: false,
      default: (): number[] => [5, 10, 25],
    } as PropOptions<number[]>,
    /**
     * Should the pagination allow all items to be shown?
     */
    allowShowAll: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * Whether or not to show the page size picker
     */
    hidePageSize: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * If the component should use a dark mode variant
     */
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * The text that is used before 'per page'
     */
    itemName: {
      type: String,
      required: false,
      default: 'Rows',
    },
  },
  computed: {
    rowsPerPage(): any[] {
      const options: any[] = [
        ...this.pageSizeOptions,
      ];

      if (this.allowShowAll) {
        options.push({ text: 'All', value: Infinity });
      }

      return options;
    },
    currentPageIndicator(): string {
      const { pageSize, currentPage } = this;
      const maxItem = Math.min(
        pageSize * (currentPage + 1),
        this.numberOfItems,
      );
      if (maxItem === 0) return '';
      const minItem = pageSize === Infinity ? 1 : pageSize * currentPage + 1;
      return `${minItem}-${maxItem} of ${this.numberOfItems}`;
    },
    prevButtonDisabled(): boolean {
      return this.disabled || this.currentPage === 0;
    },
    nextButtonDisabled(): boolean {
      return this.disabled || this.currentPage + 1 >= Math.ceil(this.numberOfItems / this.pageSize);
    },
  },
  methods: {
    pageSizeChange(value) {
      const pageSize = typeof value === 'number' ? value : value.value;
      /**
       * An event triggered when either pageSize or currentPage is updated
       * @event update
       * @type {object}
       * @property {number} pageSize
       * @property {number} currentPage
       */
      this.$emit('update', {
        pageSize,
        currentPage: 0,
      });
    },
  },
});
